import { kbbBaseUrl } from '@/constants/config';

type loaderProps = {
  src: string;
}

export default function kbbLoader({ src }: loaderProps) {
  return `${kbbBaseUrl}/${src}`;
}
